import React, { useCallback, useState, useMemo } from 'react'
import classNames from 'classnames'
import Path from '@leverege/path'
import { Button, TextInput, Dialog, Dialogs } from '@leverege/ui-elements'
import GroupAttributeView from './GroupAttributeView'

import S from './style.css'

export default function ArrayGroupAttributeView( props ) {
  const { node, deviceData, onSetValue } = props
  const path = node.path.substring( 0, node.path.length - 1 )
  const [ opened, setOpened ] = useState( true )
  const [ created, setCreated ] = useState( [] )
  const v = Path.get( path, deviceData, {} )

  const onClear = useCallback( ( e ) => {
    const onClose = Dialogs.show( {
      component : Dialog.Question,
      props : {
        title : 'Delete All Fields in Group',
        okay : 'Delete All',
        message : `Are you sure you want to delete ALL fields under "${path}"?`,
        onOkay : ( e ) => {    
          const nv = [ ...v ]
          nv.splice( e.data, 1 )
          onSetValue( { attribute : null, path, value : nv } )
          setCreated( [] )      
          onClose()
        }, 
        onCancel : () => { onClose() }
      }
    } )

  }, [ path, v, onSetValue, setCreated ] )

  const onDelete = useCallback( ( e ) => {
    if ( e.data < v.length ) {
      const nv = [ ...v ]
      nv.splice( e.data, 1 )
      onSetValue( { attribute : null, path, value : nv } )
    }
    if ( created.indexOf( e.data ) >= 0 ) {
      setCreated( created.filter( k => k !== e.data ) )
    } 
  }, [ created, v, setCreated, onSetValue, path ] )
 
  const rtn = []
  const arr = useMemo( () => { return Array.isArray( v ) ? v : [] }, [ v ] )
  created.forEach( ( k ) => {
    if ( arr.length < k + 1 ) {
      arr[k] = null
    }
  } )
  for ( let i = 0; i < arr.length; i++ ) {
    const cNode = { ...node, name : `${i}`, path : `${path}/${i}` }
    rtn.push( (
      <GroupAttributeView {...props} node={cNode} key={i} doSet={false} onDelete={onDelete} eventData={i}/>
    ) )
    rtn.push( <div key={`div-${i}`} className={S.grpAttrDiv} /> )
  }

  let name = node.name
  if ( name[name.length - 1] === '*' ) {
    name = name.slice( 0, -1 )
  }

  const onAddIndex = useCallback( ( e ) => {
    console.log( 'created', created, arr.length, created.indexOf( arr.length ) )
    if ( created.indexOf( arr.length ) < 0 ) {
      setCreated( [ ...created, arr.length ] )      
    } 
  }, [ created, arr, setCreated ] )

  return (
    <div className={S.grpAttrSpanView}>
      <div className={S.flex}>
        <div className={S.attrViewLabel}>
          <Button 
            variant="link"
            style={{ padding : '0px' }}
            icon={opened ? 'fa fa-caret-down fa-fw' : 'fa fa-caret-right fa-fw'} 
            onClick={() => setOpened( !opened )} />
          <span className={S.attrLabel}>{name}</span>
          <span className={S.attrArrow}>&rarr;</span>
          <span className={S.attrArrow}>[</span>
          { !opened && <span className={S.attrArrow}>&nbsp;]</span> }
        </div>
        <div className={S.flexRight}>
          <div className={S.attrViewPath}>{path}</div>
          <Button 
            variant="link"
            icon="fa fa-times fa-fw" 
            disabled={v.length === 0}
            eventData={node.path}
            onClick={onClear} />
        </div>
      </div>
      <div className={classNames( S.grpAttrView, S.grpAttrNested )} >
        {opened && rtn}
        { opened && (
          <Button 
            variant="link" 
            icon="fa fa-plus-circle fa-fw" 
            onClick={onAddIndex}>
            Add
          </Button>
        ) }
      </div>
      
      { opened && <div className={S.attrViewLabel}><span className={S.attrArrow}>]</span></div> }

    </div>
  )
}

const RX = /^[a-zA-Z0-9_]+$/
function validateKey( e ) {
  return RX.test( e.key )
}
